export const JOB_STATUSES = ['REVIEW', 'ACTIVE', 'DEACTIVATED'];

const DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

const clockTime = (time) => time.slice(0, 5);

const byDayThenTime = (a, b) => {
  return DAYS.indexOf(a.dayOfWeek) - DAYS.indexOf(b.dayOfWeek) || a.startTime.localeCompare(b.startTime);
};

// Loom names care needs and languages as upper snake case codes, such as MEAL_PREP.
export const displayCode = (code) => {
  const words = code.toLowerCase().replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const toClientJob = (job) => ({
  jobId: job.id,
  status: job.status,
  summary: job.summary,
  description: job.description,
  additionalConsiderations: job.additionalConsiderations,
  startWindow: job.startWindow,
  hourlyRate: Number(job.hourlyRate),
  scheduleSlots: job.scheduleSlots
      .map((slot) => ({
        dayOfWeek: slot.dayOfWeek,
        startTime: clockTime(slot.startTime),
        endTime: clockTime(slot.endTime),
      }))
      .sort(byDayThenTime),
  careNeeds: job.careNeeds.map((need) => need.skill.name),
  languages: job.languageRequirements.map((requirement) => ({
    name: requirement.language.name,
    level: requirement.level,
  })),
  // Jobs synced from Career-FE change there, so the tab shows them read-only.
  editable: job.legacyJobRn === null,
  createdAt: job.createdAt,
});

export const toJobUpdateBody = (form) => ({
  summary: form.summary.trim(),
  description: form.description.trim(),
  additionalConsiderations: form.additionalConsiderations.trim(),
  hourlyRate: Number(form.hourlyRate),
  startWindow: form.startWindow,
  scheduleSlots: form.scheduleSlots.map((slot) => ({
    dayOfWeek: slot.dayOfWeek,
    startTime: slot.startTime,
    endTime: slot.endTime,
    timezone: 'America/Toronto',
  })),
  careNeeds: form.careNeeds,
  languages: form.languages.map((language) => ({
    name: language.name,
    level: language.level,
  })),
});
